import { graphql } from '@apollo/client/react/hoc'

import getCountry from '../../helpers/get-country'
import { ApplicationError } from '../../helpers/errors'
import { graphqlToFeaturedLink } from '../../helpers/graphql-to-featured-link'
import { graphqlToMarketplaceRetailerReducer } from '../../helpers/graphql-to-marketplace-retailer-reducer'
import { WITH_NATIONAL_HOMEPAGE } from './query.ts'

export { WITH_NATIONAL_HOMEPAGE as query }

export const mapPropsToOptions = ({ staticContext }) => {
  const country = getCountry(staticContext)

  return {
    variables: { country: [country] },
    errorPolicy: 'ignore',
    context: { version: 2 },
  }
}

export const mapDataToProps = ({
  data: { error, loading, cfNationalHomepageCollection },
}) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  }
  const homepage = cfNationalHomepageCollection.items[0]
  const categories = homepage.featuredCategoriesCollection.items
  return {
    promotion: homepage.promotionModule,
    features: homepage.featuresCollection.items.map(graphqlToFeaturedLink),
    retailers: homepage.featuredRetailersCollection.items.reduce(
      graphqlToMarketplaceRetailerReducer,
      []
    ),
    featuredCategoriesCollection: categories.map(graphqlToFeaturedLink),
  }
}

const withNationalHomepage = graphql(WITH_NATIONAL_HOMEPAGE, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withNationalHomepage
